import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import footPrintImgSrc from "$/footprint.svg";

interface LoadingProps {
  visible?: boolean;
}
const width = window.innerWidth;
const widthCenter = width / 2;
const height = window.innerHeight;
const heightCenter = height / 2;
const generateFootPrint = (id: number) => ({
  id,
  x: widthCenter + (Math.random() - 0.5) * Math.min(Math.pow(id, 7), width),
  y: heightCenter + (Math.random() - 0.5) * Math.min(Math.pow(id, 7), height),
  rotate: Math.random() * 360,
});

export const Loading = ({ visible }: LoadingProps) => {
  const [footPrints, setFootPrints] = useState<
    ReturnType<typeof generateFootPrint>[]
  >([
    {
      id: 0,
      x: widthCenter,
      y: heightCenter,
      rotate: 0,
    },
  ]);
  const [intervalTime, setIntervalTime] = useState(1000);
  useEffect(() => {
    if (visible) {
      const interval = setInterval(() => {
        setFootPrints((currentFootPrints) => [
          ...currentFootPrints,
          generateFootPrint(currentFootPrints.length + 1),
        ]);
        setIntervalTime((prevTime) => Math.max(prevTime - 200, 500)); // 최대 500밀리초까지 줄어듭니다.
      }, intervalTime);

      return () => clearInterval(interval);
    } else {
      setFootPrints([
        {
          id: 0,
          x: widthCenter,
          y: heightCenter,
          rotate: 0,
        },
      ]);
    }
  }, [visible, intervalTime]);
  useEffect(() => {
    if (footPrints.length > 100) {
      throw new Error("Timeout");
    }
  }, [footPrints.length]);
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          animate={{
            opacity: 1,
          }}
          initial={{
            opacity: 0,
          }}
          exit={{
            opacity: 0,
          }}
          className="flex overflow-hidden absolute inset-0 z-50 bg-white bg-opacity-40"
        >
          {/* <span className="fixed top-1/2 left-1/2 z-50 text-xl font-bold -translate-x-1/2 -translate-y-1/2">
            잠시만 기다려주세요
          </span> */}
          {footPrints.map(({ id, ...footPrint }) => (
            <motion.img
              className="absolute origin-center"
              key={id}
              src={footPrintImgSrc}
              alt="Footprint"
              initial={{
                ...footPrint,
                opacity: 0,
                scale: 0,
              }}
              animate={{
                opacity: 1,
                scale: [0.8, 1.2, 1],
                transition: {
                  type: "spring",
                  stiffness: 300,
                  damping: 20,
                },
              }}
              exit={{ scale: 0 }}
            />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
